let _browserEventsEnabled = false;

export default {
  standardEvents: [],
  passiveStandardEvents: [],

  windowEvents: ["orientationchange", "resize"],

  documentEvents: ["webkitfullscreenchange", "mozfullscreenchange",
                    "fullscreenchange", "MSFullscreenChange", "visibilitychange"],
  listeners: {},

  dispatchCb: function(event) {
    this.emit(event.type, event);
  },

  initBrowserEvents: function(elem) {

    this.standardEvents.forEach(
      (e) => elem.addEventListener(e, this.dispatchCb.bind(this), false)
    );

    this.passiveStandardEvents.forEach(
      (e) => elem.addEventListener(e, this.dispatchCb.bind(this), {passive: true})
    );

    this.windowEvents.forEach(
      (e) => window.addEventListener(e, this.dispatchCb.bind(this), false)
    );

    this.documentEvents.forEach(
      (e) => document.addEventListener(e, this.dispatchCb.bind(this), false)
    );

    _browserEventsEnabled = true;
  },

  on: function(eventName, listener) {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }

    if (this.listeners[eventName].indexOf(listener) === - 1) {
      this.listeners[eventName].push(listener);
    }
  },

  off: function(eventName, listener) {
    if (!this.listeners[eventName]) {
      return;
    }

    const evListeners = this.listeners[eventName];
    for (var i = 0; i < evListeners.length; i++) {
      if (evListeners[i] == listener) {
        evListeners.splice(i, 1);
        break;
      }
    }
  },

  emit: function(eventName, param) {

    if (!this.listeners[eventName])
      return;

    this.listeners[eventName].forEach((l) => {
      l(param);
    });
  },

  cleanup: function(elem) {

    if (_browserEventsEnabled) {
      this.standardEvents.forEach(
        (e) => elem.removeEventListener(e, this.dispatchCb.bind(this))
      );
      this.passiveStandardEvents.forEach(
        (e) => elem.removeEventListener(e, this.dispatchCb.bind(this))
      );
      this.windowEvents.forEach(
        (e) => window.removeEventListener(e, this.dispatchCb.bind(this))
      );
      this.documentEvents.forEach(
        (e) => document.removeEventListener(e, this.dispatchCb.bind(this))
      );
    }
    this.listeners = {};
  }
};
